import PageEndBlank from '../components/PageContainer/PageEndBlank';
import Carousel from '../components/Carousel/Carousel';

const AboutUs = () => {
	return (
		<div>
			<div className="youtube-embed">
				<iframe src="https://www.youtube.com/embed/c0hK1Fzbxqc?rel=0" title="Cardinal Burke on the Holy Name of Jesus" frameborder="0" allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
			</div>

			<h1>Holy Name Society</h1>
			<div className="desktop-only"><h3>St. Joseph Parish<span className="tab"></span><span className="tab"></span>Hanover, PA</h3></div>
			<div className="mobile-only"><h3>St. Joseph Parish</h3><h3>Hanover, PA</h3></div>

			<p className="justify"><span className="tab"></span>Welcome, friends, to the Website of the Holy Name Society of St. Joseph Roman Catholic Church in Hanover, PA. Serving in ministry at St. Joseph's for over 100 years, the men of the Holy Name Society practice the teachings of our faith espoused by members throughout the years. By their example, members honor the sacred Name of Jesus Christ and promote its devotion through word and deed. By visiting this website, you will learn about our Holy Name Society: its history, its current leadership and ministries, and the reason our men are proud to wear the insignia of Blessed John of Vercelli, our patron Saint.</p>

			<Carousel scrollSeconds={16} elements={[
				(
					<figure>
						<blockquote>
							<p>After recalling the apostles, they had them flogged, ordered them to stop speaking in the name of Jesus, and dismissed them. So they left the presence of the Sanhedrin, rejoicing that they had been found worthy to suffer dishonor for the sake of the name.</p>
						</blockquote>
						<figcaption>
							<cite><a href="https://www.biblegateway.com/passage/?search=Acts%205%3A40-41&version=NABRE" rel="noreferrer" target="_blank">Acts of the Apostles 5:40-41 (NABRE)</a></cite>
						</figcaption>
					</figure>
				), (
					<figure>
						<blockquote>
							<p>The name "Jesus" signifies that the very name of God is present in the person of his Son, made man for the universal and definitive redemption from sins. It is the divine name that alone brings salvation, and henceforth all can invoke his name.</p>
						</blockquote>
						<figcaption>
							<cite><a href="https://www.usccb.org/sites/default/files/flipbooks/catechism/110/" rel="noreferrer" target="_blank">Catechism of the Catholic Church, no. 432</a></cite>
						</figcaption>
					</figure>
				), (
					<figure>
						<blockquote>
							<p>"There is no salvation through anyone else, nor is there any other name under heaven given to the human race by which we are to be saved."</p>
						</blockquote>
						<figcaption>
							<cite><a href="https://www.biblegateway.com/passage/?search=Acts%204%3A12&version=NABRE" rel="noreferrer" target="_blank">Acts of the Apostles 4:12 (NABRE)</a></cite>
						</figcaption>
					</figure>
				), (
					<figure>
						<blockquote>
							<p>But the one name that contains everything is the one that the Son of God received in his incarnation: JESUS. the divine name may not be spoken by human lips, but by assuming our humanity the Word of God hands it over to us and we can invoke it: "Jesus," "YHWH saves."</p>
						</blockquote>
						<figcaption>
							<cite><a href="https://www.usccb.org/sites/default/files/flipbooks/catechism/642/" rel="noreferrer" target="_blank">Catechism of the Catholic Church, no. 2666</a></cite>
						</figcaption>
					</figure>
				), (
					<figure>
						<blockquote>
							<p>To pray "Jesus" is to invoke him and to call him within us. His name is the only one that contains the presence it signifies. Jesus is the Risen One, and whoever invokes the name of Jesus is welcoming the Son of God who loved him and who gave himself up for him.</p>
						</blockquote>
						<figcaption>
							<cite><a href="https://www.usccb.org/sites/default/files/flipbooks/catechism/642/" rel="noreferrer" target="_blank">Catechism of the Catholic Church, no. 2666</a></cite>
						</figcaption>
					</figure>
				), (
					<figure>
						<blockquote>
							<p>Give thanks to the Lord, invoke his name; make known among the peoples his deeds! Sing praise to him, play music; proclaim all his wondrous deeds! Glory in his holy name; let hearts that seek the Lord rejoice!</p>
						</blockquote>
						<figcaption>
							<cite><a href="https://www.biblegateway.com/passage/?search=Psalm%20105%3A1-3&version=NABRE" rel="noreferrer" target="_blank">Psalm 105:1-3 (NABRE)</a></cite>
						</figcaption>
					</figure>
				), (
					<figure>
						<blockquote>
							<p>Because of this, God greatly exalted him and bestowed on him the name that is above every name, that at the name of Jesus every knee should bend, of those in heaven and on earth and under the earth, and every tongue confess that Jesus Christ is Lord, to the glory of God the Father.</p>
						</blockquote>
						<figcaption>
							<cite><a href="https://www.biblegateway.com/passage/?search=Philippians%202%3A9-11&version=NABRE" rel="noreferrer" target="_blank">Philippians 2:9-11 (NABRE)</a></cite>
						</figcaption>
					</figure>
				)
			]}></Carousel>

			<p className="justify"><strong>Mission Statement:</strong> To promote a love of God and reverence for His Holy Name, and to focus on prayer and Christian fellowship through spiritual and social activities. We know that we cannot live today alone&mdash; it must be with our Savior: in us, through us, and beside us. Doing this will enable us to fulfill the pledge we took upon our initiation into the Holy Name Society.</p>

			<p className="justify">By attending Mass and receiving the Eucharist; promoting abstinence of blasphemous, profane, and indecent language; and serving God and the parish through prayer, fellowship, and religious programs; Holy Name men remain a beacon of light for others to emulate, through and with the guidance of the Holy Spirit.</p>

			<PageEndBlank />
		</div>
	);
};

export default AboutUs;
